import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2026-05-27 14:18:05 +0200 (Wed, 27 May 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 163319 $
//  Purpose   : qa specific wiki elements
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { mapItems, strip } from 'ldash';
import log from 'uix/logging';
import { Actions, Sel } from 'uix/registries';
import { TagMatcher } from 'uix/wiki/utils';
// ---Local imports
import { BasicTimeline } from './components';
// ---Exports
export const Timeline = TagMatcher('Timeline', ({ events, days, header, text })=>{
    if (text) {
        events = text;
    }
    let eventType = events ? events.split(',').map((e)=>strip(e)).filter((e)=>e) : events;
    days = days ? parseInt(days) : days;
    return /*#__PURE__*/ _jsx(BasicTimeline, {
        eventType: eventType,
        days: days,
        header: header
    });
}, {
    eventType: [
        'ReleaseStateChange',
        'WikiChange'
    ],
    days: [
        '7',
        '30'
    ],
    header: [
        'Ereignisse'
    ]
}, 'Timeline component (element text is interpreted as comma separated list of eventTypes)');
